import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CustomerRoutingModule } from './customer-routing.module';
import { TruckDetailsComponent } from './truck-details/truck-details.component';
import { MaterialModule } from '../material/material-module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomerHeaderComponent } from './customer-header/customer-header.component';
import { ProfileComponent } from './profile/profile.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { TripsComponent } from './trips/trips.component';
import { TripsDetailsComponent } from './trips-details/trips-details.component';
import { CancellationPolicyComponent } from './cancellation-policy/cancellation-policy.component';
import { EditTruckCategoryComponent } from './edit-truck-category/edit-truck-category.component';
import { GoogleMapsModule } from "@angular/google-maps"
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CancelTripComponent } from './cancel-trip/cancel-trip.component';
import { CommonServices } from '../common.services';
import { MapTrackerComponent } from './map-tracker/map-tracker.component';
import { DeleteAccountComponent } from './delete-account/delete-account.component';
import { CustomerCancelQuoteComponent } from './customer-cancel-quote/customer-cancel-quote.component';
import { UppercaseInputDirective } from './uppercase-customer';
import { TwoDigitDecimaNumberDirective } from './two-digit-decima-number.directive';
import { UpperCaseInputDirective } from './uppercase-input.directive';
import { AlphanumericOnlyDirective } from './alpha-numeric.directives';
import { PriceChangeDailogComponent } from './price-change-dailog/price-change-dailog.component';
import { LrUpdateComponent } from './lr-update/lr-update.component';

@NgModule({
  declarations: [
    TruckDetailsComponent,
    CustomerHeaderComponent,
    ProfileComponent,
    DashboardComponent,
    TripsComponent,
    TripsDetailsComponent,
    CancellationPolicyComponent,
    EditTruckCategoryComponent,
    CancelTripComponent,
    MapTrackerComponent,
    DeleteAccountComponent,
    CustomerCancelQuoteComponent,
    UppercaseInputDirective,
    UpperCaseInputDirective,
    TwoDigitDecimaNumberDirective,
    AlphanumericOnlyDirective,
    PriceChangeDailogComponent,
    LrUpdateComponent
  ],
  imports: [
    CommonModule,
    CustomerRoutingModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
    GoogleMapsModule,
  ],
  providers: [CommonServices],
})
export class CustomerModule {}
